export function mergeSnappedCorner(existing, snapped) {
  if (!existing || !snapped) return existing;
  return {
    ...existing,
    ...snapped,
    // Snapping computes geometry, not identity. Keep stable IDs because they
    // key stored metrics, and keep the administrator's official label.
    id: existing.id,
    label: existing.label,
  };
}
